import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

/**
 * Tab de Anuidades.
 * Mostra tabela de anuidades e permite adicionar / editar / remover.
 *
 * Props:
 *  - affiliate: objeto atual (usa affiliate.affiliateAnnuities e affiliate.name)
 *  - onAdd: callback pra abrir dialog de nova anuidade
 *  - onEdit(annuity): callback pra editar
 *  - onDelete(annuity): callback pra remover
 */
export function TabAnnuities({ affiliate, onAdd, onEdit, onDelete }) {
    const { t } = useTranslation();

    const actionBodyTemplate = (rowData) => (
        <>
            <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2"
                onClick={() => onEdit(rowData)} />
            <Button icon="pi pi-trash" className="p-button-rounded p-button-danger"
                onClick={() => onDelete(rowData)} />
        </>
    );

    return (
        <>
            <p></p>
            <label htmlFor="name">{affiliate.name}</label>
            <p></p>
            <DataTable value={affiliate.affiliateAnnuities} responsiveLayout="scroll">
                <Column field="year" header={t('msg.jkaYear')} sortable style={{ minWidth: '2rem' }} />
                <Column field="paymentDate" header={t('msg.jkaAnnuityPaymentDate')} sortable style={{ minWidth: '2rem' }} />
                <Column field="value" header={t('msg.jkaValue')} sortable style={{ minWidth: '2rem' }} />
                <Column field="jkabrCardDate" header={t('msg.jkaCardIssueDate')} sortable style={{ minWidth: '2rem' }} />
                <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '6rem' }} />
            </DataTable>
            <p></p>
            <Button icon="pi pi-plus-circle" iconPos="right" onClick={onAdd} />
        </>
    );
}
